import React from 'react'
import YellowStar from '../../../img/Icons/Yellow Icons/TitanTV Icon_Star.png'
import GrayStar from '../../../img/Icons/Gray Icons/TitanTV Icon_Star_Gray.png'
import HalfStar from '../../../img/Icons/Yellow Icons/TitanTV Icon_Half_Star.png'
import { ProgramFlag, Stars, StyledStarRating } from './eventDetails/EventDetailsStyles'

const StarRating = (props: { StarRating: number }) => {
	const starRating: number = props.StarRating;
	let stars: JSX.Element[] = []


	if (starRating > 0) {
		let usableStar = starRating
		let isHalf = starRating % 1 !== 0;
		let starsLeft = 5 - starRating;
		if (isHalf) {
			usableStar = usableStar - 0.5
			starsLeft = starsLeft - 1;
		}
		for (let i = 0; i < usableStar; i++) {
			stars.push(
				<Stars src={YellowStar} />
			)
		}
		if (isHalf) {
			stars.push(<Stars src={HalfStar} />)
		}
		if (starsLeft >= 1) {
			for (let i = 0; i < starsLeft; i++) {
				stars.push(
					<Stars src={GrayStar} />
				)
			}
		}
	}

	return (
		<StyledStarRating title={`${starRating} Stars`}>{stars}</StyledStarRating>
	)
}

export default StarRating